/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.w_tabs", {
        options: {
            slickOptions:{
                arrows: false,
                autoplay: true,
                autoplaySpeed: 4000,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true,
                rows: 0,
                pauseOnFocus: false, 
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: api.vars.scr.desktop, // tablet view
                        settings: {
                            slidesToShow:2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: api.vars.scr.tablet, // mobile view
                        settings: {
                            slidesToShow:1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            }
        },

        _create: function () {
            this.wrap = this.element;

            this.tabs = $(".s-tabs__wrp", this.wrap); 
            this.tabNavItems = $(".s-tabs__nav li a", this.wrap); 

            this.tabs.tabs();    
            
            this.initCarousel()

            this.removeTabNav()      

            this.tabs.tabs({
                activate: function( event, ui ) {   
                    $('.s-tabs__simpleCards__items', this.wrap).slick('destroy')

                    $('.s-tabs__simpleCards__items', this.wrap).slick('refresh')                    
                }
              });
        } ,
        
        initCarousel(){
            $('.s-tabs__simpleCards__items', this.wrap).each((indx, el)=>{                
                $(el).on('init', (slick)=>{
                    var dots = $('.slick-dots', $(slick.target))  
                    api.fn.slickDotsInit(dots, this.options.slickOptions.autoplaySpeed/1000)
                })
                .slick(this.options.slickOptions)
                .on('beforeChange', (event, slick, currentSlide, nextSlide)=>{
                    var dots = $('.slick-dots', $(event.target))
                    api.fn.slickDotsFilled(dots, nextSlide)
                })
            });
        },

        //if we have only one tab hide tab title
        removeTabNav(){
            this.tabNavItems = this.wrap.find('.s-tabs__nav li').length; 

             if(this.tabNavItems == 1){
                 $(".s-tabs__nav", this.wrap).hide()
             }
        }     

    });
})(jQuery);



